import type { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_REQUEST_LIST_BY_MONTH_COUNT_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		months: number;
		reservationRequestStatus: ReservationRequestStatus;
	};
};

export const useReservationRequestListByMonthCountDateQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_REQUEST_LIST_BY_MONTH_COUNT_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { onConvertQueryData } = Converter.useReservationListByMonthCountQueryData();
	const { queryData } = onConvertQueryData({ serverData: data });

	return {
		queryData,
	};
};
